import React, { Suspense, useState } from "react";
import FilesActionGroup from "../../FilesActionGroup/FilesActionGroup.js";
import Icon from "../../../Elements/Icon/Icon.tsx";
import bytesToDisplayHelper from "../../../../utils/bytesToDisplayHelper.js";
import useSelfRemovalLink from "hooks/useSelfRemovalLink.tsx";
import useMultiSelectionHandler from "../helpers/useMultiSelectionHandler.ts";
import { useLightBox } from "../../../../contexts/lightBoxContext/lightBoxContext.js";
import { useMailView } from "../../../../contexts/mailViewContext/mailViewContext.js";
import { useInView } from "react-intersection-observer";
import { useActionList } from "hooks/useActionList.js";
import { useMail } from "contexts/mailContext/mailContext.js";

const availableElements = ["Image", "Audio", "Video", "Doc"];

const FileComponent = React.memo(({ fileData, id }) => {
  const Component = React.lazy(() =>
    import(
      `../../FilesTypeElement/${
        availableElements.includes(fileData.Type) ? fileData.Type : "Doc"
      }Element.jsx`
    )
  );

  return (
    <Suspense>
      <Component id={id} autoPlay={false} />
    </Suspense>
  );
});

const FileMomoizedComponent = React.memo(({ fileData, fileId }) => {
  const { setLightBox } = useLightBox();

  return (
    <div
      className="image-box"
      onClick={(e) => {
        e.stopPropagation();
        setLightBox(fileData.Type, fileId);
      }}
    >
      <FileComponent id={fileId} fileData={fileData} />
    </div>
  );
});

const SelectIconElem = ({ fileId, hover }) => {
  const { getFileSelected } = useMailView();

  const handleSelect = useMultiSelectionHandler();

  return (
    <div
      className={`select-icon${getFileSelected(fileId) ? " selected" : ""}${
        hover || getFileSelected(fileId) ? "" : " hidden"
      }`}
      onMouseDown={(e) => e.preventDefault()}
      onClick={() => {
        handleSelect(fileId);
      }}
    >
      {getFileSelected(fileId) ? <Icon name="check" white /> : null}
    </div>
  );
};

const ListItem = ({ fileId, fileData }) => {
  const [ref, inView] = useInView();
  const { getMailSecurity } = useMail();
  const { size, type } = bytesToDisplayHelper(fileData.Size);
  const [hover, setHover] = useState(false);

  const actionList = useActionList({
    security: getMailSecurity(),
  });

  const isSelfRemove = useSelfRemovalLink();

  const conditionToShowActions = inView && !isSelfRemove && hover;

  return (
    <div
      className="list-elem row"
      ref={ref}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <div className="col-6 list-elem-name">
        {isSelfRemove ? null : <SelectIconElem fileId={fileId} hover={hover} />}
        <FileMomoizedComponent {...{ fileData, fileId }} />
        &#x200E;{fileData.Name}
      </div>
      <div className="col-2">{fileData.Extention}</div>
      <div className={`col-${isSelfRemove ? "4 text-end" : "2"}`}>
        {size} {type}
      </div>
      <div className="col-2 text-end">
        {conditionToShowActions ? (
          <FilesActionGroup {...{ actionList }} itemId={fileId} />
        ) : null}
      </div>
    </div>
  );
};

export default ListItem;
